import { render, staticRenderFns } from "./BuildingsList.vue?vue&type=template&id=0b2adf1b&scoped=true"
import script from "./BuildingsList.vue?vue&type=script&lang=js"
export * from "./BuildingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2adf1b",
  null
  
)

export default component.exports